"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
/**
 * Formats a given value to a specific date format.
 * - Removes all non-digit characters.
 * - If all digits are 0 and there's more than one digit, returns an empty string.
 * - If the length of the digits is less than 3, returns the original string.
 * - If the length is between 3 and 4, returns in the format `MM/DD`.
 * - If the length is 5 or more, returns in the format `MM/DD/YYYY`.
 *
 * @param {string} value - The value to be formatted.
 * @returns {string} - The formatted date, or original/empty string based on conditions.
 */
const formatDate = (value) => {
    const d = value.replace(/[^\d]/g, "");
    if (d.length > 1 && Math.max(...d.split("").map((val) => +val)) == 0) {
        return "";
    }
    if (d.length < 3)
        return d;
    if (d.length < 5)
        return `${d.slice(0, 2)}/${d.slice(2, 4)}`;
    return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4, 8)}`;
};
exports.formatDate = formatDate;
